import type { FormControl } from '@tf/form-builder';

import constate from 'constate';
import type React from 'react';
import { useState } from 'react';

const useFormControlRefsState = () => {
	const [formControlRef, setFormControlRef] = useState<React.MutableRefObject<FormControl | null> | null>(null);

	const [submitTypeRef, setSubmitTypeRef] = useState<React.MutableRefObject<'save' | 'continue' | 'quietSave'> | null>(
		null,
	);

	return { formControlRef, setFormControlRef, submitTypeRef, setSubmitTypeRef };
};

const [FormControlRefsStateProvider, useFormControlRefHook] = constate(useFormControlRefsState);

export const useFormControlRefs = useFormControlRefHook;

export const FormControlRefsProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
	return <FormControlRefsStateProvider>{children}</FormControlRefsStateProvider>;
};
